import React, { useEffect } from 'react';

const WhatsAppButton = ({ phoneNumber = '+1234567890', message = 'Hello, I am interested in your properties!' }) => {
  useEffect(() => {
    // Remove any existing WhatsApp button first
    const existingWhatsApp = document.getElementById('whatsapp-fixed-btn');
    if (existingWhatsApp) existingWhatsApp.remove();

    // Create WhatsApp button
    const whatsappButton = document.createElement('button');
    whatsappButton.id = 'whatsapp-fixed-btn';
    whatsappButton.setAttribute('aria-label', 'Contact us on WhatsApp');
    whatsappButton.innerHTML = `
      <svg style="width: 28px; height: 28px;" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
      </svg>
    `;

    Object.assign(whatsappButton.style, {
      position: 'fixed',
      bottom: '16px',
      right: '16px',
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      backgroundColor: '#25D366',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 10px 40px rgba(34, 197, 94, 0.4)',
      transition: 'all 0.3s ease',
      padding: '10px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '99999',
      margin: '0',
      transform: 'none',
      willChange: 'auto',
      contain: 'none',
      isolation: 'auto'
    });

    whatsappButton.onclick = () => {
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${encodedMessage}`;
      window.open(whatsappUrl, '_blank');
    };

    whatsappButton.onmouseenter = () => {
      whatsappButton.style.width = '52px';
      whatsappButton.style.height = '52px';
      whatsappButton.style.boxShadow = '0 10px 40px rgba(34, 197, 94, 0.6)';
      whatsappButton.style.animationPlayState = 'paused';
      whatsappButton.style.transform = 'translateY(-6px)';
    };

    whatsappButton.onmouseleave = () => {
      whatsappButton.style.width = '48px';
      whatsappButton.style.height = '48px';
      whatsappButton.style.boxShadow = '0 10px 40px rgba(34, 197, 94, 0.4)';
      whatsappButton.style.animationPlayState = 'running';
      whatsappButton.style.transform = '';
    };

    // Always append to document.body to avoid any containing block issues
    if (document.body.style.position === 'relative') {
      document.body.style.position = 'static';
    }
    document.body.appendChild(whatsappButton);

    // Force fixed positioning and ensure button stays at root level
    const enforceFixed = () => {
      if (!whatsappButton) return;
      if (whatsappButton.parentNode !== document.body) {
        if (whatsappButton.parentNode) whatsappButton.parentNode.removeChild(whatsappButton);
        document.body.appendChild(whatsappButton);
      }
      whatsappButton.style.setProperty('position', 'fixed', 'important');
      whatsappButton.style.setProperty('z-index', '99999', 'important');
      whatsappButton.style.setProperty('bottom', '16px', 'important');
      whatsappButton.style.setProperty('right', '16px', 'important');
      whatsappButton.style.setProperty('margin', '0', 'important');
      whatsappButton.style.setProperty('top', 'auto', 'important');
      whatsappButton.style.setProperty('left', 'auto', 'important');
    };
    enforceFixed();
    window.addEventListener('scroll', enforceFixed, { passive: true });

    return () => {
      window.removeEventListener('scroll', enforceFixed);
      if (whatsappButton.parentNode) whatsappButton.remove();
    };
  }, [phoneNumber, message]);

  return null;
};

export default WhatsAppButton;
